<script>
import { computed } from 'vue';
import { useStore } from 'vuex';
export default {
    setup(){
        const store = useStore();
        const data = computed(() => store.getters.professor_honor);

        return { data };
    }

}
</script>


<template>
    <div class="h2">榮譽</div>
    <div class="table-wrapper">
        <table class="fl-table">
            <thead>
                <tr>
                    <th>類別</th>
                    <th>獲獎日期</th>
                    <th>名稱</th>
                    <th>國別</th>
                    <th>頒獎單位</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="item in data" :key="item.id">
                    <td>{{ item.category }}</td>
                    <td>{{ item.date }}</td>
                    <td>{{ item.heading }}</td>
                    <td>{{ item.country }}</td>
                    <td>{{ item.unit }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<style scoped>
.h2{
        width: 10%;
        border-radius:10px;
        background-color: gray;
        text-align:center;
        margin: 10px 10px 10px 10px;
        font-weight:bold;
        color: #fff;
}
.table-wrapper{
    margin: 20px 70px 70px;
    box-shadow: 0px 35px 50px rgba( 0, 0, 0, 0.2 );
}

.fl-table {
    border-radius: 5px;
    font-size: 12px;
    font-weight: normal;
    border: none;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    white-space: nowrap;
    background-color: white;
}

.fl-table td, .fl-table th {
    text-align: center;
    padding: 8px;
    font-size: 20px;
}

.fl-table td {
    border-right: 1px solid #f8f8f8;
    font-size: 15px;
}

.fl-table thead th {
    color: #ffffff;
    background: gray;
}

.fl-table tr:nth-child(even) {
    background: #F8F8F8;
}
@media (max-width: 767px) {
    
    .fl-table {
        display: block;
        width: 100%;
    }
    .table-wrapper:before{
        content: "Scroll horizontally >";
        display: block;
        text-align: right;
        font-size: 11px;
        color: white;
        padding: 0 0 10px;
    }
    .fl-table thead, .fl-table tbody, .fl-table thead th {
        display: block;
    }
    .fl-table thead th:last-child{
        border-bottom: none;
    }
    .fl-table thead {
        float: left;
    }
    .fl-table tbody {
        width: auto;
        position: relative;
        overflow-x: auto;
    }
    .fl-table td, .fl-table th {
        padding: 20px .625em .625em .625em;
        height: 60px;
        vertical-align: middle;
        box-sizing: border-box;
        overflow-x: hidden;
        overflow-y: auto;
        width: 120px;
        font-size: 13px;
        text-overflow: ellipsis;
    }
    .fl-table thead th {
        text-align: left;
        border-bottom: 1px solid #f7f7f9;
    }
    .fl-table tbody tr {
        display: table-cell;
    }
    .fl-table tbody tr:nth-child(odd) {
        background: none;
    }
    .fl-table tr:nth-child(even) {
        background: transparent;
    }
    .fl-table tr td:nth-child(odd) {
        background: #F8F8F8;
        border-right: 1px solid #E6E4E4;
    }
    .fl-table tr td:nth-child(even) {
        border-right: 1px solid #E6E4E4;
    }
    .fl-table tbody td {
        display: block;
        text-align: center;
    }
}
</style>